import { render, staticRenderFns } from "./r-attributes-dialog.vue?vue&type=template&id=a54ce736&scoped=true"
import script from "./r-attributes-dialog.vue?vue&type=script&lang=js"
export * from "./r-attributes-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-attributes-dialog.vue?vue&type=style&index=0&id=a54ce736&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54ce736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a54ce736')) {
      api.createRecord('a54ce736', component.options)
    } else {
      api.reload('a54ce736', component.options)
    }
    module.hot.accept("./r-attributes-dialog.vue?vue&type=template&id=a54ce736&scoped=true", function () {
      api.rerender('a54ce736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/attribute/r-attributes-dialog.vue"
export default component.exports